import { render, staticRenderFns } from "./comp8.vue?vue&type=template&id=65d3e2f6&scoped=true"
import script from "./comp8.vue?vue&type=script&lang=ts"
export * from "./comp8.vue?vue&type=script&lang=ts"
import style0 from "./comp8.vue?vue&type=style&index=0&id=65d3e2f6&prod&lang=scss"
import style1 from "./comp8.vue?vue&type=style&index=1&id=65d3e2f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d3e2f6",
  null
  
)

export default component.exports